import React, {Component} from 'react'
import {translate} from 'react-i18next'
import * as yup from 'yup'
import {InputField} from "../../components/InputField";
import {MessageModal} from "../../components/MessageModal";
import Checkbox from "./Checkbox";
import A from "../../components/A";

const initialForm = {
        company: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        location: '',
        question: '',
        attachments: [],
        agreementPolicy: false,
        agreementMailing: false,
        agreementMarketing: false,
        allConsents: false,
    };

class VCCustomContact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: initialForm,
            response: null,
            validation: null,
            isFetching: false,
            toggle: {
                agreementMailing: false,
                agreementMarketing: false
            },
            modalOpen: false
        }
        this.schema = yup.object().shape({
            company: yup.string()
                .required('You must enter company name.'),
            firstName: yup.string()
                .required('You must enter first name.'),
            lastName: yup.string()
                .required('You must enter last name.'),
            phone: yup.string()
                .required(),
            email: yup.string()
                .required('You must enter valid email.')
                .email('You must enter valid email.'),
            location: yup.string()
                .required('You must enter location.'),
            question: yup.string(),
            // FIXME: attachments validation
            attachments: yup.mixed(),
            agreementPolicy: yup.boolean()
                .test('agreementRequired', 'You must agree.', value => value),
            agreementMailing: yup.boolean()
                .test('agreementRequired', 'You must agree.', value => value)
        });

        this.checkAllConsents = this.checkAllConsents.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        // new response
        if (props.response && props.response.status && (props.response.status === 200 || props.response.status === 500))
            return {
                response: {
                    status: props.response.status,
                    message: props.response.status === 200 ? 'custom:customContactForm.success' : 'custom:customContactForm.failure'
                },
                validation: null,
                isFetching: props.response.isFetching
            }

        // new empty response
        if (props.response)
            return {
                response: null,
                validation: null,
                isFetching: props.response.isFetching
            }

        // reset response
        if (props.response === null && state.response && (state.response.status === 200 || state.response.status === 500))
            return {
                form: state.response.status === 200 ? initialForm : {...state.form},
                response: null,
                validation: null,
                isFetching: false,
            }

        return null
    }

    handleInputChange = regexp => e => {
        const target = e.target;
        const name = target.name;
        this.resetValidation(name)
        let regexpValid = true;

        if (regexp && target.type !== 'file' && target.type !== 'checkbox') {
            const regex = new RegExp(regexp);
            regexpValid = regex.test(target.value)
        }

        const form = target.type === 'file' ?
            {...this.state.form, [name]: [...this.state.form[name], ...target.files]} :
            {...this.state.form, [name]: target.type === 'checkbox' ? target.checked : target.value}

        regexpValid && this.setState({form})
    }

    resetValidation = name => {
        const validation = {...this.state.validation};
        if(validation[name] !== undefined){
            delete validation[name]
        }
        this.setState({validation})
    }

    handleFormSubmit = e => {
        e.preventDefault();

        this.schema.validate(this.state.form, {
            abortEarly: false,
        })
            .then(valid => {
                this.props.onSubmit({...this.state.form}, this.onMessageSuccess)
            })
            .catch(error => {
                const validation = {}
                error.inner.forEach(err => {
                    if (validation[err.path] === undefined) {
                        validation[err.path] = []
                    }
                    validation[err.path].push({
                        // id: Math.random(),
                        value: err.message
                    })
                })
                this.setState({validation})
            })
    }

    onMessageSuccess = () => {
        this.openModal();
        this.clearForm();
    }

    handleDeleteAttachment = e => {
        const index = parseInt(e.target.getAttribute('data-attachment-index'), 10)
        this.setState({
            form: {...this.state.form, attachments: this.state.form.attachments.filter((_, i) => i !== index)}
        })
    }

    handleToggleAgreementMailing = e => {
        this.setState({
            toggle: {...this.state.toggle, agreementMailing: !this.state.toggle.agreementMailing}
        })
    }

    handleToggleAgreementMarketing = e => {
        this.setState({
            toggle: {...this.state.toggle, agreementMarketing: !this.state.toggle.agreementMarketing}
        })
    }

    openModal = () => {
        this.setState({modalOpen: true})
    }

    closeModal = () => {
        this.setState({modalOpen: false})
    }

    clearForm = () => {
        this.setState({form: initialForm})
    };

    checkAllConsents() {
        const consents = {
            allConsents: !this.state.form.allConsents,
            agreementMailing: !this.state.form.allConsents,
            agreementPolicy: !this.state.form.allConsents,
            agreementMarketing: !this.state.form.allConsents,
        };
        this.setState({
            form: {
                ...this.state.form,
                ...consents,
            }
        });
    }

    render() {

        return (
            <div className="contact-form">
                <MessageModal
                    isOpen={this.state.modalOpen}
                    onRequestClose={this.closeModal}
                    title={this.props.t('msg.messageModal')}
                    message={this.props.t('custom:customContactForm.success')}
                />
                <h2>{this.props.t('custom:customContactForm.title1')}
                    {this.props.t('custom:customContactForm.title2')}</h2>
                <form onSubmit={this.handleFormSubmit}>
                    <span><em>*</em> {this.props.t('custom:customContactForm.required')}</span>
                    <div className="row">
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.company ? ' error' : '' }`}
                            onChange={this.handleInputChange()}
                            value={this.state.form.company}
                            label={this.props.t('custom:customContactForm.company')}
                            required
                            type="text"
                            name="company"
                        />
                    </div>
                    <div className="row">
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.firstName ? ' error' : '' }`}
                            onChange={this.handleInputChange()}
                            value={this.state.form.firstName}
                            label={this.props.t('custom:customContactForm.firstName')}
                            required
                            type="text"
                            name="firstName"
                        />
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.lastName ? ' error' : '' }`}
                            onChange={this.handleInputChange()}
                            value={this.state.form.lastName}
                            label={this.props.t('custom:customContactForm.lastName')}
                            required
                            type="text"
                            name="lastName"
                        />
                    </div>
                    <div className="row">
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.phone ? ' error' : '' }`}
                            onChange={this.handleInputChange("^\\+?[0-9 ]*$")}
                            value={this.state.form.phone}
                            label={this.props.t('custom:customContactForm.phone')}
                            required
                            type="text"
                            name="phone"
                        />
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.email ? ' error' : '' }`}
                            onChange={this.handleInputChange()}
                            value={this.state.form.email}
                            label={this.props.t('custom:customContactForm.email')}
                            required
                            type="text"
                            name="email"
                        />
                    </div>
                    <div className="row">
                        <InputField
                            className={`col-md-6${ this.state.validation && this.state.validation.location ? ' error' : '' }`}
                            onChange={this.handleInputChange()}
                            value={this.state.form.location}
                            label={this.props.t('custom:customContactForm.location')}
                            required
                            type="text"
                            name="location"
                        />
                    </div>
                    <div className="row">
                        <div
                            className={`col-md-12${ this.state.validation && this.state.validation.question ? ' error' : '' }`}>
                            <label>{this.props.t('custom:customContactForm.question')}</label>
                            <textarea
                                name="question"
                                value={this.state.form.question}
                                onChange={this.handleInputChange()}/>
                        </div>
                    </div>
                    <p><strong>{this.props.t('custom:customContactForm.attachmentsTitle')}</strong></p>
                    <div 
                        className={`attachments${ this.state.validation && this.state.validation.attachments ? ' error' : '' }`}>
                        {this.state.form.attachments && this.state.form.attachments.map((file, index) => (
                            <div key={index} className="attachment">
                                <span>{file.name}</span>
                                <a className="remove" data-attachment-index={index}
                                   onClick={this.handleDeleteAttachment}> </a>
                            </div>
                        ))}
                    </div>
                    <div className="add-file">
                        <input type="file" id="attachment" name="attachments" onChange={this.handleInputChange()} multiple/>
                        <label htmlFor="attachment">{this.props.t('custom:customContactForm.attachmentsButton')}</label>
                    </div>

                    <Checkbox
                        id='allConsents'
                        name='allConsents'
                        isChecked={this.state.form.allConsents}
                        value={this.state.form.allConsents}
                        onChange={this.checkAllConsents}
                    >

                        {
                            this.state.form.allConsents
                                ? this.props.t('custom:customContactForm.uncheckAllConsents')
                                : this.props.t('custom:customContactForm.checkAllConsents')
                        }
                    </Checkbox>

                    <Checkbox
                        id='agreementPolicy'
                        name='agreementPolicy'
                        value={this.state.form.agreementPolicy}
                        isChecked={this.state.form.agreementPolicy}
                        hasError={this.state.validation && this.state.validation.agreementPolicy}
                        onChange={this.handleInputChange()}
                    >
                        <div>
                            <em>*</em> {this.props.t('custom:customContactForm.agreementPolicy')}&nbsp;
                            <A href={this.props.t('custom:customContactForm.agreementPolicyAHref')}>
                                <strong>{this.props.t('custom:customContactForm.agreementPolicyATitle')}</strong>
                            </A>
                        </div>
                    </Checkbox>

                    <Checkbox
                        id='agreementMailing'
                        name='agreementMailing'
                        value={this.state.form.agreementMailing}
                        isChecked={this.state.form.agreementMailing}
                        hasError={this.state.validation && this.state.validation.agreementMailing}
                        onChange={this.handleInputChange()}
                    >
                        <div>
                            <em>*</em> {this.props.t('custom:customContactForm.agreementMailing1')}<br/>
                            <p className={`agreement-info${ this.state.toggle.agreementMailing ? ' visible' : '' }`}>
                                {this.props.t('custom:customContactForm.agreementMailing2')}
                            </p>
                            <a className="show-hide" onClick={this.handleToggleAgreementMailing}>
                                ({this.state.toggle.agreementMailing ? this.props.t('custom:customContactForm.fold') : this.props.t('custom:customContactForm.expand')})
                            </a>
                        </div>
                    </Checkbox>

                    <Checkbox
                        id='agreementMarketing'
                        name='agreementMarketing'
                        value={this.state.form.agreementMarketing}
                        isChecked={this.state.form.agreementMarketing}
                        hasError={this.state.validation && this.state.validation.agreementMarketing}
                        onChange={this.handleInputChange()}
                        className='checkbox-wrapper-fluid'
                    >
                        <div>
                            {this.props.t('custom:customContactForm.agreementMarketing1')}<br/>
                            <p className={`agreement-info${ this.state.toggle.agreementMarketing ? ' visible' : '' }`}>
                                {this.props.t('custom:customContactForm.agreementMarketing2')}
                            </p>
                            <a className="show-hide" onClick={this.handleToggleAgreementMarketing}>
                                ({this.state.toggle.agreementMarketing ? this.props.t('custom:customContactForm.fold') : this.props.t('custom:customContactForm.expand')})
                            </a>
                        </div>
                    </Checkbox>

                    {/* <div className="captcha">
            <img src="img/captcha.png" alt="captcha" />
          </div> */}
                    <button type="submit"
                            disabled={this.state.isFetching}>{this.props.t('custom:customContactForm.submit')}</button>
                </form>
            </div>
        )
    }
}

export default translate()(VCCustomContact)


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomContactForm.js